import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { cancelAppointment } from '../../../../actions/appointmentsActions';
import { useAppointmentsSkeletonApi } from './api';
import CurrentAppointmentsV2 from './current';
import PastAppointmentsV2 from './past';

const AppointmentsV2Component = ({ patient, user, cancelAppointment }) => {
  const pastRef = useRef();

  const {
    current,
    past,
    currentVisible,
    pastVisible,
    goToPastAppointments,
    goToCurrentAppointments,
    setCurrentPage,
    cancelAppointment: handleCancelAppointment,
  } = useAppointmentsSkeletonApi({ patient, cancelAppointment });

  return (
    <div className="streaming-records-wrapper">
      <CurrentAppointmentsV2
        section={current}
        cancelAppointment={handleCancelAppointment}
        goToPastAppointments={goToPastAppointments}
        isVisible={currentVisible}
        city={user.city}
      />

      <PastAppointmentsV2
        pastRef={pastRef}
        section={past}
        setCurrentPage={setCurrentPage}
        goToCurrentAppointments={goToCurrentAppointments}
        isVisible={pastVisible}
        city={user.city}
      />
    </div>
  );
};

const mapStateToProps = ({ patient, user }) => ({ patient, user });

const mapDispatchToProps = { cancelAppointment };

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentsV2Component);
